"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSeasonRefProperty = exports.seasonRefPropertyDefinition = void 0;
exports.seasonRefPropertyDefinition = {
    view: {
        label: 'Seasons',
        readonly: true,
        hint: 'Read-only. Please navigate to the content you\'d want to remove or add in order to make changes.',
    },
    constraints: [
        {
            name: 'stencils',
            argument: ['season'],
        },
    ],
    type: 'child-ref',
    multiple: true,
    name: 'season-ref',
};
const isSeasonRefProperty = (prop) => {
    return prop.name === exports.seasonRefPropertyDefinition.name;
};
exports.isSeasonRefProperty = isSeasonRefProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2Vhc29uLXJlZi5wcm9wZXJ0eS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9wcm9wZXJ0aWVzL3NlYXNvbi1yZWYucHJvcGVydHkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBRWEsUUFBQSwyQkFBMkIsR0FBRztJQUN6QyxJQUFJLEVBQUU7UUFDSixLQUFLLEVBQUUsU0FBUztRQUNoQixRQUFRLEVBQUUsSUFBSTtRQUNkLElBQUksRUFBRSxrR0FBa0c7S0FDekc7SUFDRCxXQUFXLEVBQUU7UUFDWDtZQUNFLElBQUksRUFBRSxVQUFVO1lBQ2hCLFFBQVEsRUFBRSxDQUFDLFFBQVEsQ0FBQztTQUNyQjtLQUNGO0lBQ0QsSUFBSSxFQUFFLFdBQVc7SUFDakIsUUFBUSxFQUFFLElBQUk7SUFDZCxJQUFJLEVBQUUsWUFBWTtDQUNhLENBQUE7QUFJMUIsTUFBTSxtQkFBbUIsR0FBRyxDQUFDLElBQWtCLEVBQTZCLEVBQUU7SUFDbkYsT0FBTyxJQUFJLENBQUMsSUFBSSxLQUFLLG1DQUEyQixDQUFDLElBQUksQ0FBQTtBQUN2RCxDQUFDLENBQUE7QUFGWSxRQUFBLG1CQUFtQix1QkFFL0IifQ==